import Vue from 'vue'
const VueMoment = require('vue-moment')
const moment = require('moment')
require('moment/locale/es')

Vue.use(VueMoment, {
	moment
})

